module.exports = __webpack_public_path__ + "img/b_log_new.26f9eee1.png";